export const getBoolean = (value) => {
  if (value === 'true') {
    return true
  }
  if (value === 'false') {
    return false
  }
}
